export default function QuestionFrame() {
    return <svg data-name="question-frame">
        <path style={{
            // transform: 'translate(15px, 0px)'
        }} className="cls-3" d="M1055.21,111.27,9.64,107.15c-4.86-.09-8.68-1.76-8.7-3.81L0,24.65c0-2.13,4.05-3.88,9.1-3.91l1045.41-9.46c5,0,9.16,1.68,9.18,3.81l1.1,92.28C1064.82,109.58,1060.44,111.36,1055.21,111.27Z"/>
        <path className="cls-2" d="M1064.67,100,27.73,95.87c-4.81-.08-8.6-1.75-8.62-3.81l-.93-78.69c0-2.13,4-3.88,9-3.9L1064,0c5,0,9.09,1.68,9.11,3.81l1.09,92.28C1074.2,98.3,1069.86,100.09,1064.67,100Z"/>
    </svg>;
}
